import { render, staticRenderFns } from "./disabled.vue?vue&type=template&id=46c6acd5"
import script from "./disabled.vue?vue&type=script&lang=js"
export * from "./disabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports